import { createStorage } from './createStorage';

export const useSessionStorage = createStorage('session');
